import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {ReplaySubject} from 'rxjs/ReplaySubject';

@Injectable()
export class FieldsService {

  private createFieldManager: ReplaySubject<any> = new ReplaySubject<any>(null);
  public createField: Observable<any>;

  private deleteFieldManager: ReplaySubject<void> = new ReplaySubject<void>(null);
  public deleteField: Observable<void>;

  constructor(private http: HttpClient) {
    this.createField = this.createFieldManager.asObservable();
    this.deleteField = this.deleteFieldManager.asObservable();
  }

  list() {
    return this.http.get('/api/fields');
  }

  listFieldValues() {
    return this.http.get('/api/fields/fieldValues');
  }

  editFieldValues(id, data) {
    return this.http.put(`/api/fields/fieldValues/${id}`, data);
  }

  create(field) {
    return this.http.post('/api/fields', field)
      .do((res: any) => {
        this.createFieldManager.next(res);
      });
  }

  delete(id) {
    return this.http.delete(`/api/fields/${id}`)
      .do(() => {
        this.deleteFieldManager.next(null);
      });
  }

  edit(id, data) {
    return this.http.put(`/api/fields/${id}`, data);
  }

  massEdit(data) {
    return this.http.put('/api/fields', data);
  }

}



// WEBPACK FOOTER //
// ./client/app/core/fields/fields.service.ts